import VisuallyHidden from 'components/VisuallyHidden/VisuallyHidden';

export default VisuallyHidden;
